import moment from "moment";
import React from "react";
import Cookies from "universal-cookie";
import giustificaAssenza from "../../services/giustificaAssenza";
import rimuoviGiustificaAssenza from "../../services/rimuoviGiustifica";

export default class AssenzaWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      giustificata: props.assenza.giustificata === "1",
    };
  }

  async justifyAssenza() {
    if (!this.state.giustificata) {
      const cookies = new Cookies();
      const username = cookies.get("username", { path: "/" });
      const token = cookies.get("token", { path: "/" });

      let res = await giustificaAssenza(
        username,
        token,
        this.props.assenza.id_studente,
        this.props.assenza.id_lezione
      );
      if (res !== null && res.result === "ok") {
        this.setState({ giustificata: true });
        this.props.onChange(true);
      } else {
        alert(
          "Si è verificato un errore inatteso durante la giustificazione di questa assenza. Per favore, riprova."
        );
      }
    }
  }

  async rimuoviGiustifica() {
    if (this.state.giustificata) {
      const cookies = new Cookies();
      const username = cookies.get("username", { path: "/" });
      const token = cookies.get("token", { path: "/" });

      let res = await rimuoviGiustificaAssenza(
        username,
        token,
        this.props.assenza.id_studente,
        this.props.assenza.id_lezione
      );
      if (res !== null && res.result === "ok") {
        this.setState({ giustificata: false });
        this.props.onChange(false);
      } else {
        alert(
          "Si è verificato un errore inatteso durante la rimozione di questa giustifica. Per favore, riprova."
        );
      }
    }
  }

  render() {
    const isCrossCorso = this.props.assenza.cross_corso === true;
    const hasSessione =
      this.props.assenza.id_sessione &&
      this.props.assenza.id_sessione !== null &&
      this.props.assenza.id_sessione !== "null" &&
      this.props.assenza.id_sessione !== "";
    const isRecuperata =
      this.props.assenza.id_recupero && this.props.assenza.id_recupero !== null;

    return (
      <section style={{ marginBottom: "10px" }}>
        <div
          style={{
            justifyContent: "space-between",
            display: "flex",
            alignContent: "center",
          }}
        >
          <p>
            Assenza data{this.props.assenza.materia}:
            {moment(this.props.assenza.data, "yyyy-MM-DD HH:mm:ss").format(
              "DD/MM/yyyy"
            )}
            {hasSessione && (
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "0.85em",
                  color: "#666",
                  fontStyle: "italic",
                }}
              >
                (mezza giornata)
              </span>
            )}
            {isCrossCorso && (
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "0.85em",
                  backgroundColor: "#FFA500",
                  color: "white",
                  padding: "2px 6px",
                  borderRadius: "4px",
                  fontWeight: "bold",
                }}
              >
                Da corso precedente
              </span>
            )}
            {isRecuperata && (
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "0.85em",
                  backgroundColor: "#28a745",
                  color: "white",
                  padding: "2px 6px",
                  borderRadius: "4px",
                  fontWeight: "bold",
                }}
              >
                Recuperata
              </span>
            )}
          </p>
          {!this.state.giustificata && (
            <p
              style={{
                paddingLeft: "10px",
                paddingRight: "10px",
                paddingTop: "5px",
                paddingBottom: "5px",
                borderRadius: "10px",
                boxShadow: "0px 2px 10px darkgrey",
                backgroundColor: this.state.pressed ? "#5E8141" : "#7FA85D",
                color: "white",
                fontWeight: "bold",
                cursor: "pointer",
              }}
              onMouseEnter={() => this.setState({ pressed: true })}
              onMouseLeave={() => this.setState({ pressed: false })}
              onClick={this.justifyAssenza.bind(this)}
            >
              Giustifica
            </p>
          )}
          {this.state.giustificata && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  paddingTop: "5px",
                  paddingBottom: "5px",
                  color: "green",
                  fontWeight: "bold",
                }}
              >
                Giustificata
              </p>
              <p
                style={{
                  paddingLeft: "10px",
                  paddingRight: "10px",
                  paddingTop: "5px",
                  paddingBottom: "5px",
                  marginLeft: 15,
                  borderRadius: "10px",
                  boxShadow: "0px 2px 10px darkgrey",
                  backgroundColor: this.state.pressed ? "#814141" : "#A85D5D",
                  color: "white",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
                onMouseEnter={() => this.setState({ pressed: true })}
                onMouseLeave={() => this.setState({ pressed: false })}
                onClick={this.rimuoviGiustifica.bind(this)}
              >
                Rimuovi
              </p>
            </div>
          )}
        </div>
      </section>
    );
  }
}
